var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelephone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 7,
    fill: "url(#paint0_linear_197_615)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5155 24.7604C19.4533 23.0682 18.0763 20.9801 17.3523 19.792L16.8123 18.7761C17.0011 18.5739 18.441 17.0353 19.065 16.2005C19.8491 15.1522 18.7122 14.2055 18.7122 14.2055C18.7122 14.2055 15.5133 11.0128 14.7843 10.3795C14.0552 9.74531 13.216 10.0975 13.216 10.0975C11.6838 11.0855 10.0953 11.9445 10 16.0755C9.99645 19.9431 12.9386 23.9323 16.1202 27.0206C19.3069 30.5083 23.6822 34.004 27.9123 34C32.0515 33.9058 32.912 32.3209 33.902 30.7918C33.902 30.7918 34.2552 29.955 33.6204 29.2268C32.9851 28.4989 29.7853 25.306 29.7853 25.306C29.7853 25.306 28.8372 24.1712 27.7865 24.9544C27.0035 25.5385 25.5974 26.8377 25.2587 27.1527C25.2593 27.1538 22.9072 25.9025 21.5155 24.7604Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_615",
    x1: -5.90244,
    y1: -5.36585,
    x2: 44,
    y2: 48.8293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A31F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A31F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.5c3cf54ef75bfe4c6d7c946bd69cbed6.svg";
export { ForwardRef as ReactComponent };